export var AssessmentEventType;
(function (AssessmentEventType) {
    AssessmentEventType["TEST_PROGRESS"] = "TEST_PROGRESS";
    AssessmentEventType["PRE_CHECK_PROGRESS"] = "PRE_CHECK_PROGRESS";
    AssessmentEventType["TEST_STARTED"] = "TEST_STARTED";
    AssessmentEventType["TEST_FINISHED"] = "TEST_FINISHED";
    AssessmentEventType["PRE_CHECK_STATUS"] = "PRE_CHECK_STATUS";
    AssessmentEventType["EXAM_STARTED"] = "EXAM_STARTED";
    AssessmentEventType["EXAM_STATISTICS"] = "EXAM_STATISTICS";
    AssessmentEventType["UPLOAD_IN_PROGRESS"] = "UPLOAD_IN_PROGRESS";
    AssessmentEventType["EXPECTED_ANSWERS"] = "EXPECTED_ANSWERS";
})(AssessmentEventType || (AssessmentEventType = {}));
export var FaceDetectionEventType;
(function (FaceDetectionEventType) {
    FaceDetectionEventType["VIOLATION_CAMERA_MULTIPLE_FACES"] = "VIOLATION_CAMERA_MULTIPLE_FACES";
    FaceDetectionEventType["VIOLATION_CAMERA_NO_FACES"] = "VIOLATION_CAMERA_NO_FACES";
})(FaceDetectionEventType || (FaceDetectionEventType = {}));
// TODO should probably be stored in one enum
export var DevicesChangedEventType;
(function (DevicesChangedEventType) {
    DevicesChangedEventType["MICROPHONE_DEVICES_CHANGED"] = "MICROPHONE_DEVICES_CHANGED";
    DevicesChangedEventType["SPEAKER_DEVICES_CHANGED"] = "SPEAKER_DEVICES_CHANGED";
    DevicesChangedEventType["DISPLAY_DEVICES_CHANGED"] = "DISPLAY_DEVICES_CHANGED";
    DevicesChangedEventType["CAMERA_DEVICES_CHANGED"] = "CAMERA_DEVICES_CHANGED";
})(DevicesChangedEventType || (DevicesChangedEventType = {}));
export var ViolationBackgroundApplicationEvent;
(function (ViolationBackgroundApplicationEvent) {
    ViolationBackgroundApplicationEvent["VIOLATION_BACKGROUND_APPLICATIONS"] = "VIOLATION_BACKGROUND_APPLICATIONS";
    ViolationBackgroundApplicationEvent["VIOLATION_BLUETOOTH_CONNECTIONS"] = "VIOLATION_BLUETOOTH_CONNECTIONS";
})(ViolationBackgroundApplicationEvent || (ViolationBackgroundApplicationEvent = {}));
export var ViolationOutOfFocusApplicationEvent;
(function (ViolationOutOfFocusApplicationEvent) {
    ViolationOutOfFocusApplicationEvent["VIOLATION_APPLICATION_OUT_OF_FOCUS"] = "VIOLATION_APPLICATION_OUT_OF_FOCUS";
})(ViolationOutOfFocusApplicationEvent || (ViolationOutOfFocusApplicationEvent = {}));
export var ViolationInputDictationEvent;
(function (ViolationInputDictationEvent) {
    ViolationInputDictationEvent["VIOLATION_INPUT_DICTATION"] = "VIOLATION_INPUT_DICTATION";
})(ViolationInputDictationEvent || (ViolationInputDictationEvent = {}));
export var LicenseProcessListEvent;
(function (LicenseProcessListEvent) {
    LicenseProcessListEvent["PROCESS_LIST"] = "PROCESS_LIST";
})(LicenseProcessListEvent || (LicenseProcessListEvent = {}));
export var ExamEventStage;
(function (ExamEventStage) {
    ExamEventStage["PRETEST"] = "PRETEST";
    ExamEventStage["EXAM"] = "EXAM";
})(ExamEventStage || (ExamEventStage = {}));
//# sourceMappingURL=license-events.interface.js.map